import { gql } from '@apollo/client'

export const RELEASE_BOUNDING_BOX_LEASES = gql`
  mutation ReleaseBoundingBoxLeases($boxIds: [ID!]!) {
    releaseBoundingBoxLeases(boxIds: $boxIds) {
      __typename
      ... on ReleaseBoundingBoxLeasesResult {
        ok
      }
    }
  }
`
